import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { ICountry } from '../models/country.model';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private httpClient = inject(HttpClient);

  private urlBase: string = 'api/countries';
  private countries$: Observable<ICountry[]>;

  getAllCountries(): Observable<ICountry[]> {
    this.countries$ = this.countries$ ?? this.fetchAllCountries().pipe(shareReplay());
    return this.countries$;
  }

  private fetchAllCountries(): Observable<ICountry[]> {
    return this.httpClient.get<ICountry[]>(this.urlBase);
  }
}
